import { Box, Button, Text } from '@chakra-ui/react';
import { useUpdateProcedureMutation } from '@services/data/procedure.api';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { ProcedureStep, ProcedureStepStateEnum } from '@/types/config/procedure.types';

import { useProcedureTabContext } from '../ProcedureTab';
import ProcedureInstructions from './ProcedureInstructions';

type Props = {
  step: ProcedureStep;
  procedureId: string;
};

function AcknowledgementStep({ step, procedureId }: Readonly<Props>) {
  const [updateProcedure, { isLoading }] = useUpdateProcedureMutation();
  const { canManage, notificationId } = useProcedureTabContext();
  if (!canManage) {
    return <ProcedureInstructions instructions={step.instructions} />;
  }

  const onClick = () => {
    updateProcedure({
      notificationId: notificationId,
      procedureId,
      step: step.rank,
      state: ProcedureStepStateEnum.CONFIRMED,
    });
  };

  return (
    <>
      <Box
        paddingY={5}
        paddingX={6}
        backgroundColor="neutral.700"
        width="100%"
        flex={step.instructions.length > 0 ? 0 : 1}
      >
        <Button disabled={isLoading} loading={isLoading} variant="toggle" size="toggleM" onClick={onClick}>
          <Text>
            <FormattedMessage id="notification.procedure.step.type.ACKNOWLEDGEMENT.acknowledgement" />
          </Text>
        </Button>
      </Box>
      <ProcedureInstructions instructions={step.instructions} />
    </>
  );
}

export default memo(AcknowledgementStep);
